import React from 'react';
import './CircuitRecords.css';

export default function CircuitRecords({
  circuits,
  selectedCircuit,
  vehicleRecords,
  customerRecords,
  handleCircuitSelection,
}) {
  return (
    <div className="circuit-records-page">
      <br />
      <h2 className="title">Circuit Records</h2>

      <div className="dropdown-container">
        <select
          className="circuit-dropdown"
          onChange={(e) => handleCircuitSelection(e.target.value)}
          defaultValue=""
        >
          <option value="" disabled>Select a Circuit</option>
          {circuits.map((circuit) => (
            <option key={circuit.id} value={circuit.id}>
              {circuit.name}
            </option>
          ))}
        </select>
      </div>

      {/* Display vehicle records */}
      {selectedCircuit && vehicleRecords.length > 0 && (
        <div className="vehicle-records-section">
          <h3>{selectedCircuit.name} Vehicle Records</h3>
          <table>
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Driver</th>
                <th>Time</th>
                <th>Date</th>
                <th>Venue</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {vehicleRecords.map((record, index) => (
                <tr key={index}>
                  <td>{record.vehicle_name}</td>
                  <td>
                    <a href={`/driver/${record.customer_id}`} className="driver-link">
                      {record.customer_name}
                    </a>
                  </td>
                  <td>{record.lap_time_str}</td>
                  <td>{new Date(record.date).toLocaleDateString()}</td>
                  <td>{record.venue_name}</td>
                  <td>
                    <a href={record.telemetry_uri} target="_blank" rel="noopener noreferrer">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="chart-line"
                        className="svg-inline--fa fa-chart-line fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                        ></path>
                      </svg>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Display customer records */}
      {selectedCircuit && customerRecords.length > 0 && (
        <div className="customer-records-section">
          <h3>{selectedCircuit.name} Customer Records</h3>
          <table>
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Driver</th>
                <th>Time</th>
                <th>Date</th>
                <th>Venue</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {customerRecords.map((record, index) => (
                <tr key={index}>
                  <td>{record.vehicle_name}</td>
                  <td>
                    <a href={`/driver/${record.customer_id}`} className="driver-link">
                      {record.customer_name}
                    </a>
                  </td>
                  <td>{record.lap_time_str}</td>
                  <td>{new Date(record.date).toLocaleDateString()}</td>
                  <td>{record.venue_name}</td>
                  <td>
                    <a href={record.telemetry_uri} target="_blank" rel="noopener noreferrer">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="chart-line"
                        className="svg-inline--fa fa-chart-line fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                        ></path>
                      </svg>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
